// extracted by mini-css-extract-plugin
module.exports = {"root":"UserNav_root__14Dws","tab":"UserNav_tab__oEGXG"};